import React from 'react'

import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Copy
} from 'components'
import { StatusIcon, MagnifyingGlassIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { Item } from 'services/NGT/Wallet'
import { COLORS, FORMAT } from 'utils'

interface ITableSearchCre {
  tableData: Item[]
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  rowsPerPage: number
  // eslint-disable-next-line no-unused-vars
  selectedContractInfo: (contractId: number) => void
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>
  pageCount: number
  isSearchDisabled: boolean
}

export const TableSearchCre = ({
  tableData,
  pageCount,
  page,
  selectedContractInfo,
  rowsPerPage,
  setRowsPerPage,
  setPage,
  isSearchDisabled
}: ITableSearchCre) => {
  const history = useHistory()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleClickItemCre = (data: Item) => {
    history.push({
      pathname: '/ngt/analise-cre',
      state: {
        cdContrato: data.codigoContrato,
        dtCompetencia: data.nuAnoMesCompetencia,
        idCreExist: data.creId,
        nmFornecedor: data.nomeFornecedor,
        pathBack: '/ngt/carteira-cre',
        tab: 0
      }
    })
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Todos os documentos liberados, após análise'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Em Processo de Análise'
    if (
      status === 'Red' ||
      status === 'Bloqueado' ||
      status === 'Recusado' ||
      status === 'DocumentoRecusado' ||
      status === 'B'
    )
      return 'Documento Recusado, após análise'
    return 'Documentos não analisados no Sistema'
  }

  const INVALID_DATE = '01/01/0001'

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="center">Código de Centro</TableCellStyled>
              <TableCellStyled align="left" minwidth="130px">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="center">Competência</TableCellStyled>
              <TableCellStyled align="center">1ª Mob</TableCellStyled>
              <TableCellStyled align="center">Últ. Mob.</TableCellStyled>
              <TableCellStyled align="center">Denúncia</TableCellStyled>
              <TableCellStyled align="center">Projeto</TableCellStyled>
              <TableCellStyled align="center">Alerta</TableCellStyled>
              <TableCellStyled align="center">Nº CRE</TableCellStyled>
              <TableCellStyled align="center">Analista</TableCellStyled>
              <TableCellStyled align="center">Valor Folha</TableCellStyled>
              <TableCellStyled align="center">Data Entrada</TableCellStyled>
              <TableCellStyled align="center">Últ. Análise</TableCellStyled>
              <TableCellStyled align="center">SLA</TableCellStyled>
              <TableCellStyled align="center">Status</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.length > 0 &&
              tableData?.map((row, index) => (
                <TableRowStyled
                  key={`table-item-${row.idMovimentacao}-${index}`}
                >
                  <TableCellStyled align="left">
                    <Copy
                      title="Copiar código de contrato"
                      valueToCopy={row.codigoContrato}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Link
                      onClick={() => selectedContractInfo(row.idContrato)}
                      color={COLORS.blueFonts}
                    >
                      {row.codigoContrato || '---'}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled align="center">{row.cdCentro || '---'}</TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nomeFornecedor || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {moment(row.nuAnoMesCompetencia).format('MM/YYYY') || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flPrimeiraMobilizacao} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flUltMedicao} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flDenuncia} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flProjeto} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flAlerta} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.codigoCRE || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.nomeAnalista || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.currency(row.vlFolha) || '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.slaDtAnalise &&
                      FORMAT.formatDDMMYYYY(row.slaDtAnalise) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.slaDtAnalise)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.dtUltAnaliseCRE &&
                      FORMAT.formatDDMMYYYY(row.dtUltAnaliseCRE) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.dtUltAnaliseCRE)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.vlSla !== null ? row?.vlSla : '---'}
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    title={handleStatus(row.txStatusColor)}
                    placement="left"
                  >
                    <TableCellStyled align="center">
                      <StatusIcon value={row.txStatusColor} marginLeft="10px" />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled align="center" style={{ paddingLeft: '0.8rem' }}>
                    <Link onClick={() => handleClickItemCre(row)}>
                      <MagnifyingGlassIcon style={{ justifyContent: 'left' }} />
                    </Link>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        disabled={isSearchDisabled}
        page={page}
        rows={tableData}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="online"
      />
    </>
  )
}
